export default function (textToTranslate) {
  let currentLang = $('.navigationMain__languageSwitcher li.current-lang a').text();

  if (currentLang === 'en') {
    return textToTranslate;
  }

  let de = {
    'Read more': 'Mehr lesen',
    'Less': 'Weniger',
  };

  return de[textToTranslate];
}



// WEBPACK FOOTER //
// ./scripts/util/i18n.js